/**
 * Force imports under the loadable to be resolved early in all jest tests.
 * This prevents the first running test from becoming disproportionately slow.
 * Leaves behavior in integration tests unchanged.
 */
export function shouldForceImportsForJest() {
	return !!process.env.JEST_WORKER_ID;
}
